import {
  SET_TOURNAMENT_STATUS_FOR_TOURNAMENT_STATUS,
  SET_TOURNAMENT_HAS_PENDING_CHANGES_FOR_TOURNAMENT_STATUS,
  SET_AVAILABLE_STATUSES_FOR_TOURNAMENT_STATUS,
  PUBLISH_STARTS_FOR_TOURNAMENT,
  PUBLISH_ENDS_FOR_TOURNAMENT,
  DISPLAY_CONFIRM_MODAL_FOR_STATUS_CHANGE,
  CANCEL_CONFIRM_MODAL_FOR_STATUS_CHANGE,
  SET_EXPORT_SYSTEM_INFO,
  LOADING_STARTS_FOR_TOURNAMENT,
  LOADING_ENDS_FOR_TOURNAMENT,
  SET_EXPORT_STATUS
} from './constants';

export const setTournamentStatus = status => ({
  type: SET_TOURNAMENT_STATUS_FOR_TOURNAMENT_STATUS,
  payload: status
});

export const setTournamentHasPendingChanges = hasPendingChanges => ({
  type: SET_TOURNAMENT_HAS_PENDING_CHANGES_FOR_TOURNAMENT_STATUS,
  payload: hasPendingChanges
});

export const setAvailableStatuses = statuses => ({
  type: SET_AVAILABLE_STATUSES_FOR_TOURNAMENT_STATUS,
  payload: statuses
});

export const publishStarts = () => ({
  type: PUBLISH_STARTS_FOR_TOURNAMENT
});

export const publishEnds = () => ({
  type: PUBLISH_ENDS_FOR_TOURNAMENT
});

export const displayConfirmStatusChangeModal = status => ({
  type: DISPLAY_CONFIRM_MODAL_FOR_STATUS_CHANGE,
  payload: status
});

export const cancelConfirmStatusChangeModal = () => ({
  type: CANCEL_CONFIRM_MODAL_FOR_STATUS_CHANGE
});

export const setExportSystemInfo = exportSystemData => ({
  type: SET_EXPORT_SYSTEM_INFO,
  payload: exportSystemData
});

export const loadingStarts = () => ({
  type: LOADING_STARTS_FOR_TOURNAMENT
});

export const loadingEnds = () => ({
  type: LOADING_ENDS_FOR_TOURNAMENT
});

export const setExportStatus = exportStatusData => ({
  type: SET_EXPORT_STATUS,
  payload: exportStatusData
});


// WEBPACK FOOTER //
// ./src/features/tournament/status/actionTypes.js